export { default } from './SWSectionQuickLinks';
